import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const deleteAppointments = async ({ ids }) => {
  const token = localStorage.getItem("token");

  const response = await axios.delete(`${__API_URL__}/api/appointments/delete_appointments/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
    data: {
      list_of_ids: ids,
    },
  });

  return response.data;
};

const useDeleteAppointmentsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAppointments,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patient_appointments"] });
    },
    onError: (error) => {
      console.error("Failed to delete appointments:", error);
    },
  });
};

export default useDeleteAppointmentsMutation;
